import gql from 'graphql-tag';
export const GET_COMPANY = gql `
  query Company($id: UUID!) {
    company(id: $id) {
      id
      tenantId
      createdAt
      companyName
      contactName
      countryId
      state
      locale
      email
      personas
      blackList
      settings {
        defaultCurrency
      }
      billing {
        firstName
        lastName
        currency
        identifierType
        identifier
        fiscalEntity
        zipCode
        city
        address
        phone
        editable
        billingPeriod
      }
    }
  }
`;
//# sourceMappingURL=company.js.map